import axios from "axios";

import { getParams } from "../../Application/utils/query";
import withAbortSignal from "../../common/decorators/withAbortSignal";
import { type FilterSlice, SortType } from "features/AssetResults/types";
import { type HistoryItem } from "../types";
import { EntityType } from "features/common/types";

// Helper function to convert type string to EntityType
function mapTypeToEntityType(type: string): EntityType | null {
  const lowerType = type.toLowerCase();

  switch (lowerType) {
    case "flow":
      return EntityType.Flow;
    case "externalevent":
      return EntityType.Event;
    case "video":
      return EntityType.Video;
    case "pdf":
      return EntityType.Pdf;
    case "assessment":
      return EntityType.Assessment;
    case "survey":
      return EntityType.Survey;
    case "embeddedvideo":
      return EntityType.EmbeddedVideo;
    default:
      return null;
  }
}

function addSortParams(params: URLSearchParams, sortType: SortType) {
  if (sortType === SortType.Recent) {
    params.append("sortOrder", "desc");
    params.append("sortBy", "issuedDate");
  }
}

async function fetchHistoryResultsCore(
  filters: FilterSlice,
  sort = SortType.Relevant,
  signal?: AbortSignal,
): Promise<HistoryItem[]> {
  const params = getParams();

  addSortParams(params, sort);

  Object.entries(filters).forEach(([key, value]) => {
    if ((key === "from" || key === "to") && value.toString() !== "") {
      const dateValue = value.toString();
      params.append(`date${key[0].toUpperCase()}${key.slice(1)}`, dateValue);
    } else if (value.length > 0) {
      value.forEach(f => {
        if (f === "EmbeddedVideo") return; // Removing until the myHistory endpoint supports this type
        return params.append(key, f.toString());
      });
    }
  });

  const path = "/api/reports/v1/users/me/history";

  const response = await axios.get(path, { params, signal: signal });
  return response.data.map((item: HistoryItem) => ({
    ...item,
    Type: mapTypeToEntityType(item.Type),
  }));
}

export const fetchHistoryResultsSearch = withAbortSignal(fetchHistoryResultsCore);
